import * as React from 'react';
import { TModalFooter } from './ModalFooter.types';
import { Button } from '@mui/material';
import '../../Modals.styled.scss';

export const ModalFooter: TModalFooter = ({
  onCancel,
  onApply,
  cancelButtonTitle = 'Cancel',
  applyButtonTitle = 'Apply',
  isLoading,
}) => {
  if (!onCancel && !onApply) {
    return null;
  }
  return (
    <div className="modal__footer">
      {onCancel && <Button onClick={onCancel}>{cancelButtonTitle}</Button>}
      {onApply && (
        <div className="modal__footer__apply">
          <Button
            className="modal__footer__apply"
            onClick={onApply}
            disabled={isLoading}
            variant="contained"
          >
            {applyButtonTitle}
          </Button>
        </div>
      )}
    </div>
  );
};
